import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

export const passengersListFormGroup = (formBuilder: FormBuilder): FormGroup => {
  return formBuilder.group({
    name: ['', []],
    group: ['', []],
  });
};